module.exports = "/_next/static/images/d14fd9cad4501fa1f32369b77d642b74-bill-icon.svg.webp";